import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import DialogAudioController from "./DialogAudioController";

export default class DialogAudioCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {DialogAudioController} dialogAudioController 
     */
    constructor(dispatcher, dialogAudioController) {
        super(dispatcher);

        this._dialogAudioController = dialogAudioController;
    }

    execute(evt) {
        /** @type {NGTDialogPlayer} */
        const contentPlayer = evt.params.contentPlayer;
        /** @type {content: AudioContent} */
        const content = evt.params.data.data.content;

        /** @type {{id: string, loop: boolean, channel: int}} */
        const audioJson = content.getAudio();
        if (!audioJson) {
            console.warn(`${DialogAudioCommand.name}: Audio json was null, ignoring...`, audioJson, content);
            contentPlayer.contentCompleted(content);
            return;
        }

        this._dialogAudioController.playAudio(audioJson);
        contentPlayer.contentCompleted(content);
    }
}